// Matches the pulumi env names + dev

import z from 'zod/v4';

const ProdEnv = z.enum(['dev', 'staging', 'prod', 'ci']);
type ProdEnv = z.infer<typeof ProdEnv>;

export type Config = {
  rawBackendUrl: string;
  backendUrl: string;
  consumerAppUrl: string;
  cognito: {
    userPoolId?: string;
    clientId?: string;
    identityPoolId?: string;
  };

  logoutTimer: string;

  posthog: {
    apiHost?: string;
    apiKey?: string;
  };
  sentryDns?: string;

  useCognito: boolean;
  isProduction: boolean;
  prodEnv?: ProdEnv;

  /** Used for amplify region setting  */
  aws: {
    region: string;
  };
};

const config: Config = {
  cognito: {
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID
  },
  useCognito:
    Boolean(import.meta.env.VITE_COGNITO_CLIENT_ID) &&
    Boolean(import.meta.env.VITE_COGNITO_USER_POOL_ID),
  prodEnv: ProdEnv.safeParse(import.meta.env.VITE_PROD_ENV).data ?? undefined,

  logoutTimer: import.meta.env.VITE_LOGOUT_TIMER ?? '600',

  posthog: {
    apiHost: import.meta.env.VITE_POSTHOG_API_HOST,
    apiKey: import.meta.env.VITE_POSTHOG_API_KEY
  },
  // Sentry
  sentryDns: import.meta.env.VITE_SENTRY_DNS,

  // This needs to be fixed. The legacy is taht we didn't have the rest backend before
  rawBackendUrl: import.meta.env.VITE_BACKEND_URL ?? 'http://localhost:3000',
  backendUrl: import.meta.env.VITE_BACKEND_URL
    ? `${import.meta.env.VITE_BACKEND_URL}/graphql`
    : 'http://localhost:3000/graphql',
  consumerAppUrl:
    import.meta.env.VITE_CONSUMER_APP_URL ?? 'http://localhost:5173/',
  isProduction: import.meta.env.MODE === 'production',

  aws: {
    region: 'us-east-1'
  }
};

export default config;
